import { Box, SxProps } from '@mui/material';
import BudgetProgressBar from 'app/shared-components/ui/BudgetProgress/BudgetProgressBar';
import { format } from 'date-fns';
import { useMemo } from 'react';
import {
  Budget,
  BudgetProgressSize,
  Spent,
  getAmountHelperText,
  getAvailableOrSpentAmountValue,
  getBudgetHelperText,
} from './utils';

interface BudgetProgressProps {
  isUnlimited?: boolean;
  spent: Spent;
  budget?: Budget;
  yearAndMonth?: string;
  sx?: SxProps;
  size?: BudgetProgressSize;
  dark?: boolean;
}

function BudgetProgress({
  isUnlimited = false,
  spent,
  budget,
  yearAndMonth = format(new Date(), 'yyyy-MM'),
  sx,
  size = 'regular',
  dark = false,
}: BudgetProgressProps) {
  const AMOUNT_VALUE = useMemo(
    () => getAvailableOrSpentAmountValue(size, spent, isUnlimited, budget, dark),
    [size, spent, isUnlimited, budget, dark]
  );

  const AMOUNT_HELPER_TEXT = useMemo(
    () => getAmountHelperText(size, spent, isUnlimited, budget, dark),
    [size, spent, isUnlimited, budget, dark]
  );

  const BUDGET_HELPER_TEXT = useMemo(
    () => getBudgetHelperText(size, spent, yearAndMonth, isUnlimited, budget, dark),
    [size, spent, yearAndMonth, isUnlimited, budget, dark]
  );

  return (
    <Box sx={sx}>
      <Box display="flex" alignItems="baseline">
        {AMOUNT_VALUE}

        {AMOUNT_HELPER_TEXT}
      </Box>

      <BudgetProgressBar sx={{ height: 3 }} isUnlimited={isUnlimited} spent={spent} budget={budget} />

      {BUDGET_HELPER_TEXT}
    </Box>
  );
}

export default BudgetProgress;
